import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React, { useState } from 'react';

import ElementInterpolator from 'root/client/components/element-interpolator/element-interpolator';

import Chip from 'root/client/components/chip/chip';
import ClubLink from 'root/client/components/club-link/club-link';
import LocationSearch from 'root/client/components/location-search/location-search';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type {
  CheckoutSelectClub as Props,
  Region,
} from './checkout-select-club.types';
import ContentContainer from 'root/client/components/content-container/content-container';

const CheckoutSelectClub: React.FC<Props> = ({ experimental, layout }) => {
  const [selectedRegion, setSelectedRegion] = useState<Region>(
    experimental.defaultSelectedRegion,
  );

  return (
    <SalesLayout {...layout}>
      <ContentContainer width={ContentContainer.widths.Narrow}>
        <div className="checkout-select-club-v2">
          <LocationSearch {...experimental.locationSearch} />
          <div className="checkout-select-club-v2__filters-section">
            <div className="checkout-select-club-v2__filters-section-header">
              <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
                {experimental.filterHeaderTitle}
              </Text>
              <Text
                className="checkout-select-club-v2__club-count"
                size={Text.sizes.small}
              >
                <ElementInterpolator
                  template={experimental.clubCountTemplate}
                  elements={{
                    clubCount: (
                      <Text size={Text.sizes.small}>
                        {experimental.defaultSelectedRegion.clubs.length.toString()}
                      </Text>
                    ),
                  }}
                />
              </Text>
            </div>
            <div
              aria-label={experimental.regionFilterLabel}
              className="checkout-select-club-v2__filters"
              role="group"
            >
              {experimental.regions.map(region => (
                <Chip
                  key={region.name}
                  label={region.name}
                  onClick={() => setSelectedRegion(region)}
                  selected={selectedRegion.name === region.name}
                />
              ))}
            </div>
            <div className="checkout-select-club-v2__filtered-club-count">
              <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
                {selectedRegion.name}
              </Text>
              <Text
                className="checkout-select-club-v2__club-count"
                size={Text.sizes.small}
              >
                <ElementInterpolator
                  template={experimental.clubCountTemplate}
                  elements={{
                    clubCount: (
                      <Text size={Text.sizes.small}>
                        {selectedRegion.clubs.length.toString()}
                      </Text>
                    ),
                  }}
                />
              </Text>
            </div>
          </div>

          <div className="checkout-select-club-v2__clubs">
            {selectedRegion.clubs.map(club => (
              <ClubLink {...club} key={club.href} />
            ))}
          </div>
        </div>
      </ContentContainer>
    </SalesLayout>
  );
};

export default CheckoutSelectClub;
